import { useAdminUpdate } from '@reapitform/hooks'
import { AdminFormField, AdminFormFieldPayload } from '../types'

/** Creates a form field under a section (`POST /api/review-card-sections/{sectionRef}/fields`). */
export const useCreateAdminFormField = (sectionReferenceID: string) =>
  useAdminUpdate<AdminFormFieldPayload, AdminFormField>({
    path: `/api/review-card-sections/${sectionReferenceID}/fields`,
    method: 'POST',
    errorMessage: 'Failed to create the field',
    successMessage: 'Field created',
  })
